module.exports = __webpack_public_path__ + "img/3.d49cb6db.jpg";